export const DEAL_CREATED = 'deal_created';
export const ASSIGNED_DEPOSIT_DATE = 'assigned_deposite_date';
export const ASSIGNED_DEAL_DATE = 'assigned_deal_date';
export const DEAL_FINISHED = 'deal_finished';
export const REFUSE = 'refuse';
export default [ASSIGNED_DEPOSIT_DATE, ASSIGNED_DEAL_DATE, DEAL_FINISHED];
